import { cn } from "@/lib/utils";

export default function SupplierTabs({
  activeTabIndex,
  setActiveTabIndex,
}: {
  activeTabIndex: number;
  setActiveTabIndex: (index: number) => void;
}) {
  return (
    <div className="flex h-[48px] border-b border-[#e4e4e7]">
      <TabItem
        isActive={activeTabIndex === 0}
        label="Paydaş"
        total={124}
        index={0}
        setActiveTabIndex={setActiveTabIndex}
      />
      <TabItem
        isActive={activeTabIndex === 1}
        label="Tedarikçi"
        total={124}
        index={1}
        setActiveTabIndex={setActiveTabIndex}
      />
    </div>
  );
}

const TabItem = ({
  isActive,
  label,
  total,
  index,
  setActiveTabIndex,
}: {
  isActive: boolean;
  label: string;
  total: number;
  index: number;
  setActiveTabIndex: (index: number) => void;
}) => {
  return (
    <div
      className="flex-1 cursor-pointer"
      onClick={() => setActiveTabIndex(index)}
    >
      <div
        className={cn(
          "flex border-b-2 items-center justify-center h-full mx-[20px] ",
          {
            " border-primary text-primary": isActive,
            "border-transparent text-muted-foreground hover:text-primary ":
              !isActive,
          }
        )}
      >
        <div className="flex gap-[4px] items-center">
          <div className="text-[14px] font-[700]  leading-[20px] mt-[4px]">
            {label}
          </div>
          <div className="text-[12px] mt-[2px] bg-[#F4F4F5] h-[20px] px-[4px] text-muted-foreground rounded-[4px] flex items-center justify-center font-[Inter] font-[500]  leading-[32px]">
            {total}
          </div>
        </div>
      </div>
    </div>
  );
};
